<div #container [ngClass]="{'selected': isSelectedJob, 'upload-item-container': true}">
    <div class="upload-item-info">
        <div class="upload-item-id-addr">
            <span class="upload-item-id">#{{service.id | shortenJobID}}</span>
            <span class="upload-item-address">- {{service.address?.indexOf(',') > -1 ? service.address?.substring(0, service.address?.indexOf(',')) : service?.address}}</span>
        </div>
        <span class="upload-item-date" *ngIf="service?.imagesToDeliver?.length < 1 || !!(currentUploads$|async)[service?.id]; else canDeliverButton">{{service.received | date: 'd MMM y'}}</span>
      <ng-template #canDeliverButton>
        <button mat-raised-button
                class="btn btn-green deliver-btn"
                [disabled]="jobDeliverPending || deleteInProgress"
                (click)="deliverJob()">
          Deliver
          <ng-template [ngIf]="jobDeliverPending">
            <div class="lds-hourglass"></div>
          </ng-template>
        </button>
      </ng-template>
    </div>
</div>
